export const PHONES = {
  PRIMARY: '0800 1234',
  SECONDARY: '2700 1234'
}

export const EMAILS = {
  INFO: 'info@tenesseguro.com'
}

export const WHATSAPP = {
  NUMBER: '099 123 456',
  LINK: 'https://api.whatsapp.com/send?phone=598'
}

export const ADDRESS = {
  STREET: 'Ellauri',
  NUMBER: '333',
  CITY: 'Montevideo',
  COUNTRY: 'Uruguay'
}
